// import Vue from 'vue'
import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getSitesEditorModuleStateKey } from '@/utils/util'

// const mixinsComputed = Vue.config.optionMergeStrategies.computed
// const mixinsMethods = Vue.config.optionMergeStrategies.methods

const mixin = {
  computed: {
    ...mapState({
      layoutMode: state => state.app.layout,
      navTheme: state => state.app.theme,
      primaryColor: state => state.app.color,
      colorWeak: state => state.app.weak,
      fixedHeader: state => state.app.fixedHeader,
      fixSiderbar: state => state.app.fixSiderbar,
      fixSidebar: state => state.app.fixSiderbar,
      contentWidth: state => state.app.contentWidth,
      autoHideHeader: state => state.app.autoHideHeader,
      sidebarOpened: state => state.app.sidebar,
      multiTab: state => state.app.multiTab
    })
  },
  methods: {
    isTopMenu() {
      return this.layoutMode === 'topmenu'
    },
    isSideMenu() {
      return !this.isTopMenu()
    }
  }
}

const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  methods: {
    isMobile() {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop() {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet() {
      return this.device === DEVICE_TYPE.TABLET
    },
  }
}

const AppDeviceEnquire = {
  mounted() {
    const { $store } = this
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop')
          $store.dispatch('setSidebar', true)
          break
        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet')
          $store.dispatch('setSidebar', false)
          break
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile')
          $store.dispatch('setSidebar', true)
          break
      }
    })
  }
}

const tableListMixin = {
  data() {
    return {
      alert: {
        show: () => this.selectedRows.length > 0,
        clear: () => {
          this.selectedRowKeys = []
        }
      },
      queryParam: {},
      selectedRowKeys: [],
      selectedRows: [],
      bulkActionModel: {
        show: false,
        title: '确定批量删除',
        content: '',
        loading: false,
        finishedItemCount: 0
      },
    }
  },
  methods: {
    bulkAction(action) {
      const actionHash = {
        delete: {
          title: `真的要删除这 ${this.selectedRows.length}项 吗?`,
          content: '删除后不可恢复! 谨慎操作!',
          actionPostfix: 'delete',
          show: true
        },
        on: {
          title: `真的要上架这 ${this.selectedRows.length}项 吗?`,
          content: '点击确认即可!',
          actionPostfix: 'update/on',
          show: true
        },
        off: {
          title: `真的要下架这 ${this.selectedRows.length}项 吗?`,
          content: '点击确认即可!',
          actionPostfix: 'update/off',
          show: true
        }
      }
      if (!actionHash[action]) {
        return
      }
      this.$confirm({
        title: actionHash[action].title,
        content: actionHash[action].content,
        onOk: async () => {
          await this.doBulkAction(actionHash[action].actionPostfix)
        },
      })
      // this.bulkActionModel = { ...actionHash[action] }
    },
    async doBulkAction(actionPostfix) {
      await Promise.all(
        this.selectedRows.map(async item => {
          await this.$http.post(`${this.modulePath}/${item.id}/${actionPostfix}`)
          return true
        })
      )
      this.$message.success('操作成功')
      this.$refs.table.refresh()
      this.$refs.table.clearSelected()
      this.bulkActionModel.show = false
    },
    async doAction(id, action, successMsg = '操作成功') {
      const xi = await this.$http.post(`${this.modulePath}/${id}/${action}`)
      if (xi.code === '0') {
        this.$error({
          title: '错误',
          content: xi.message
        })
        return false
      }
      this.$message.success(successMsg)
      this.$refs.table.refresh()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    async onRefresh(isReset) {
      // await this.getDict('state')
      // await this.getDict('group')
      if (isReset) {
        this.queryParam = { ...this.defaultQueryParam }
      }
      this.$refs.table.refresh(true)
    }
  }
}
// 拖拽右边
const siteRightMixin = {
  props: {
    moduleProp: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      form: {
        cover: '',
        plId: ''
      }
    }
  },
  computed: {
    ...mapState('sitesEditor', {
      item: function (state) {
        return state[getSitesEditorModuleStateKey('item', this.moduleProp)] || {}
      }
    }),
    coverFileList() {
      if (this.form.cover) {
        return [this.form.cover]
      }
      return []
    }
  },
  methods: {
    ...mapMutations('sitesEditor', ['update']),
    ...mapActions('sitesEditor', ['getModuleData', 'updateModuleData']),
    async updateCardTile(moduleProp) {
      const data = {
        id: moduleProp.id,
        title: moduleProp.title
      }
      await this.$http.post(`/b/material/web/home/orgCardItems/update`, data)
    },
    async updateToServer(key) {
      // const stateKey = getSitesEditorModuleStateKey('isSubmitting', this.moduleProp)
      const data = {}
      const moduleData = {}
      moduleData[key] = this.item[key]
      // data[stateKey] = true
      // await this.update(data)
      await this.updateModuleData({
        moduleProp: this.moduleProp,
        moduleData
      })
      // data[stateKey] = false
      await this.update(data)
      // this.$notification['success']({
      //   message: '保存成功'
      // })
    },
    // async coverUploaded(files) {
    //   this.form.cover = files[0]
    //   const id = this.moduleProp.id
    //   const data = {
    //     photo: files[0],
    //     itemId: id
    //   }
    //   await this.axios.post(`/b/material/web/home/org/updateTeacherInfo`, data)
    //   // console.log('1', files[0])
    // },
  },
}
// const sitePlaygroundMixin = {
//   props: {
//     moduleProp: {
//       type: Object,
//       default: () => { }
//     }
//   },
//   computed: {
//     ...mapState('sitesEditor', {
//       item: function (state) {
//         return state[getSitesEditorModuleStateKey('item', this.moduleProp)] || {}
//       }
//     })
//   },
//   methods: {
//     ...mapActions('sitesEditor', ['getModuleData']),
//     async initData() {
//       await this.getModuleData(this.moduleProp)
//     }
//   },
//   mounted() {
//     this.initData()
//   }
// }

export { mixin, AppDeviceEnquire, mixinDevice, tableListMixin, siteRightMixin }
